import { Model } from '@vuex-orm/core';

import applyBaseModelMixin from '@/models/mixins/base-model';

export default class Move extends Model {
  static entity = 'moves';

  static fields() {
    return {
      userId: this.attr(),

      correction: this.string().nullable(),
      dealerHand: this.string(),
      move: this.string(),
      playerHand: this.string(),
      gameId: this.string(),

      user: this.belongsTo('users', 'userId'),
    };
  }

  static apiConfig = {
    actions: {
      reset: {
        method: 'put',
        url: '/moves/reset',
      },
    },
  };
}

applyBaseModelMixin(Move);
